module.exports = __webpack_public_path__ + "static/media/vasilii.608ecea9.jpg";